import { useStoreState, useStoreActions } from 'easy-peasy';

export const useLeagueSelection = () => {
    const leagueLevel = useStoreState(state => state.leagueSelection.selectedLeagueLevel);
    const changeLeagueLevel = useStoreActions(actions => actions.leagueSelection.changeLeagueLevel);

    return { leagueLevel, changeLeagueLevel };
};